var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.101 0C50.12 0 .685 27.087.685 60.5S50.119 121 111.1 121V0z",
    fill: "#e95832"
  })));
}
export default __webpack_public_path__ + "static/media/subtract.c5b97f1e.svg";
export { SvgSubtract as ReactComponent };